import { CurrencyEnum, EmploymentFormsEnum, WorkFormatsEnum, WorkLoadsEnum, requestDefaultLanguage } from '@constants';
import { RequestItem } from '@innowise-group/core';

export const requestDefaultWorkFormats = [
  { dictionaryValueId: WorkFormatsEnum.Office, checked: false },
  { dictionaryValueId: WorkFormatsEnum.Mixed, checked: false },
  { dictionaryValueId: WorkFormatsEnum.Remote, checked: false },
];

export const requestDefaultWorkloads = [
  { dictionaryValueId: WorkLoadsEnum.PartTime, checked: false },
  { dictionaryValueId: WorkLoadsEnum.FullTime, checked: false },
];

export const requestDefaultEmploymentForms = [
  { dictionaryValueId: EmploymentFormsEnum.Employee, checked: false },
  { dictionaryValueId: EmploymentFormsEnum.Contractor, checked: false },
  { dictionaryValueId: EmploymentFormsEnum.Entrepreneur, checked: false },
  { dictionaryValueId: EmploymentFormsEnum.Internship, checked: false },
  { dictionaryValueId: EmploymentFormsEnum.Courses, checked: false },
];

export const requestFormDefaultValues: RequestItem = {
  name: '',
  customers: [],
  isBillable: 'true',
  unitId: '',
  divisionId: '',
  currency: CurrencyEnum.USD,
  // US-10.1: the priority is not prefilled, the field shows its placeholder
  priority: '',
  deadline: null,
  requiredCount: 1,
  professions: [],
  domains: [],
  forPreoffer: false,
  forProject: false,
  cities: [],
  countries: [],
  offices: [],
  candidateCountry: '',
  candidateCity: '',
  languages: [requestDefaultLanguage],
  salaryMin: '',
  salaryMax: '',
  employmentForms: requestDefaultEmploymentForms,
  workFormats: requestDefaultWorkFormats,
  workloads: requestDefaultWorkloads,
  comment: '',
  isCommentRestricted: false,
};
